import { Chip, Stack, Typography } from "@mui/material";

const ChipWithCount = ({
  singularLabel,
  pluralLabel,
  count,
}: {
  singularLabel: string;
  pluralLabel: string;
  count: number | string;
}) => {
  return (
    <Chip
      variant="outlined"
      label={
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography
            component="span"
            sx={{
              backgroundColor: "background.dark",
              borderRadius: 12,
              minWidth: 20,
              height: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 2,
              ml: "-8px !important",
            }}
          >
            {count}
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color="text.secondary"
          >
            {count === 1 ? singularLabel : pluralLabel}
          </Typography>
        </Stack>
      }
    />
  );
};

export default ChipWithCount;
